import React from 'react';
import PropTypes from 'prop-types';
import PageLoadBoundary from '%app/js/common/components/PageLoadBoundary';
import NetworkErrorState from '../NetworkErrorState';
import { pageLoadFailureTranslationsShape } from './propTypes';

function PageLoadFailureBoundary({ translations, children, resetKey = null }) {
    return (
        <PageLoadBoundary
            resetKey={resetKey}
            renderFallback={({ onRetry }) => (
                <NetworkErrorState
                    title={translations.pageLoadFailureTitle}
                    description={translations.pageLoadFailureDescription}
                    retryLabel={translations.commonRetry}
                    onRetry={onRetry}
                    testId="page-load-failure"
                    retryTestId="page-load-failure-retry"
                />
            )}
        >
            {children}
        </PageLoadBoundary>
    );
}

PageLoadFailureBoundary.propTypes = {
    translations: pageLoadFailureTranslationsShape.isRequired,
    children: PropTypes.node.isRequired,
    resetKey: PropTypes.string,
};

export default PageLoadFailureBoundary;
